import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Vuetify, { VApp, VBtn } from 'vuetify/lib';
import App from './App.vue';
import router from './router';
import store from './store';
import './stylus/main.styl';
import VeeValidate from 'vee-validate';
import messagesEn from './strings/validator/messages/en.js';
import messagesJa from './strings/validator/messages/ja.js';
import { localeHandler } from './utils';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueAnalytics from 'vue-analytics';
import * as VueGoogleMaps from 'vue2-google-maps';
import Geocoder from '@pderas/vue2-geocoder';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://0b068bec565f4d079d26501f9a0de7c4@sentry.io/1489433',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    environment: process.env.NODE_ENV
  });
}

Vue.config.productionTip = false;

if (process.env.VUE_APP_GA_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA_ID,
    router
  });
}

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localeHandler.getLocale() // ja-JP en-US 等に対応
});

Vue.use(VeeValidate, {
  locale: 'ja',
  i18n,
  dictionary: {
    ja: messagesJa,
    en: messagesEn
  }
});
Vue.use(Vuetify, {
  components: {
    VApp,
    VBtn
  },
  theme: {
    // primary: '#F87060',
    primary: '#385168',
    secondary: '#55355e',
    accent: '#1C1C1C',
    error: '#b71c1c'
  }
});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyARydUcOrO42fyqUAmd5Q4r6ZRXCMLiEWA',
    libraries: 'places'
  }
});

Vue.use(Geocoder, {
  defaultMode: 'address', // or 'lat-lng'
  googleMapsApiKey: 'AIzaSyD_ZsCyK1bH2qDAQlQTM3eU_zVyNC1u5uw'
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

if (localeHandler.getLocale() === 'ja') {
  document.title = '手続きシステム';
} else {
  document.title = 'Verification System';
}
